import { Routes, Route } from 'react-router-dom';
import SuperAdminLayout from '@/components/layout/SuperAdminLayout';
import SuperAdminDashboard from '@/pages/superadmin/SuperAdminDashboard';
import SuperAdminArenas from '@/pages/superadmin/SuperAdminArenas';
import SuperAdminBanners from '@/pages/superadmin/SuperAdminBanners';

const SuperAdminPage = () => {
  return (
    <Routes>
      <Route path="/" element={<SuperAdminLayout />}>
        <Route index element={<SuperAdminDashboard />} />
        <Route path="arenas" element={<SuperAdminArenas />} />
        <Route path="banners" element={<SuperAdminBanners />} />
      </Route>
    </Routes>
  );
};

export default SuperAdminPage;
